module.exports = __webpack_public_path__ + "static/media/11.eec734d0.jpg";